import React from 'react';
import AtsTooltip from 'ats/components/ats-tooltip/AtsTooltip';

function AvatarPlaceholder({ size, placeholderText }) {
	const fontSize = size ? Math.max(10, Math.round(size * 0.5)) : 10;

	return (
		<div
			className="user-profile-avatar__placeholder"
			style={{ width: size, height: size }}>
			<span
				className="user-profile-avatar__placeholder-text"
				style={{ fontSize: `${fontSize}px` }}>
				{placeholderText}
			</span>
		</div>
	);
}

function UserProfileAvatar({
	imageUrl,
	name,
	showName = false,
	showTooltip = true,
	tooltipPosition = 'top',
	size = 16,
	placeholderText
}) {
	const isURLAbsolute = url => {
		return url.indexOf('://') > 0 || url.indexOf('//') === 0;
	};
	const buildAbsoluteURL = url => {
		return `${process.env.REACT_APP_API}${url}`;
	};

	const getPlaceholderText = () => {
		if (placeholderText) return placeholderText;
		if (name) return name.charAt(0).toUpperCase();
		return 'U';
	};

	const containerStyle = !showName ? { width: size, height: size } : {};
	const avatarElement = imageUrl ? (
		<img
			src={!isURLAbsolute(imageUrl) ? buildAbsoluteURL(imageUrl) : imageUrl}
			alt={name || 'User profile'}
			className="user-profile-avatar__image"
			style={{ width: size, height: size }}
		/>
	) : (
		<AvatarPlaceholder size={size} placeholderText={getPlaceholderText()} />
	);

	if (showTooltip && !showName && name) {
		return (
			<AtsTooltip text={name} placement={tooltipPosition}>
				<div className="user-profile-avatar__container" style={containerStyle}>
					{avatarElement}
				</div>
			</AtsTooltip>
		);
	}

	return (
		<div className="user-profile-avatar__container" style={containerStyle}>
			{avatarElement}
			{showName && <span className="user-profile-avatar__name">{name}</span>}
		</div>
	);
}

export default UserProfileAvatar;
